module.exports = __webpack_public_path__ + "img/virtual-musium.9e3192c8.jpg";